/**
 * Redaction shared by everything the client sends about itself: the error
 * beacon's paths, and the log ring that rides it. One masking rule, so a new
 * caller cannot get a weaker one by accident.
 */

/** Mask UUID-shaped segments in a path or string (e.g. /sessions/:id) so an
 *  incidental id is never re-logged. */
export function redactUuids(path: string): string {
  return path.replace(
    /[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}/gi,
    ':id',
  );
}

/**
 * Clamp a string to max BYTES of UTF-8, marking the cut. The beacon's body
 * cap counts bytes, and this text is headed there, so the clamp speaks the
 * cap's unit — a 300-char clamp on 3-byte characters would triple past a
 * 300-byte budget silently.
 */
export function clampBytes(s: string, maxBytes: number): string {
  const encoder = new TextEncoder();
  if (encoder.encode(s).length <= maxBytes) return s;
  // Binary-search the longest prefix (leaving room for the marker) whose
  // encoding fits: O(log n) encodes, exact at any alphabet.
  const marker = '…';
  const budget = maxBytes - encoder.encode(marker).length;
  let lo = 0;
  let hi = s.length;
  while (lo < hi) {
    const mid = Math.ceil((lo + hi) / 2);
    if (encoder.encode(s.slice(0, mid)).length <= budget) lo = mid;
    else hi = mid - 1;
  }
  return s.slice(0, lo) + marker;
}
